import { useCallback } from 'react';
import { tc } from '../../lib/trackingContext';
import { useCart } from '../useCart';

export enum CheckoutStep {
  ShippingAddress = 1,
  ShippingMethod = 2,
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  PaymentMethod = 3
}

export const useCheckoutStepTracking = (checkoutStep: CheckoutStep) => {
  const { cart, loaded: cartLoaded } = useCart();

  const trackStep = useCallback(
    (event: 'Checkout Step Viewed' | 'Checkout Step Completed') => {
      if (cartLoaded) {
        tc.track(event, {
          addToScopeOnce: {
            checkoutStep,
            products: cart.attributes.cartItems.map(item => item.data)
          }
        });
      }
    },
    [cart.attributes.cartItems, cartLoaded, checkoutStep]
  );

  const trackCheckoutStepView = useCallback(() => {
    trackStep('Checkout Step Viewed');
  }, [trackStep]);

  const trackCheckoutStepComplete = useCallback(() => {
    trackStep('Checkout Step Completed');
  }, [trackStep]);

  return { trackCheckoutStepView, trackCheckoutStepComplete };
};
